import type {
  SiteCategoriesResponse,
  SiteCategoriesSummaryResponse
} from "./backend-types";

function addOrIncrementLicense(
  licenses: SiteCategoriesSummaryResponse["license"],
  license: SiteCategoriesResponse["license"]
): SiteCategoriesSummaryResponse["license"] {
  const existing = licenses.find((entry) => entry.value === license);

  if (existing) {
    return licenses.map((entry) =>
      entry === existing ? { ...entry, count: entry.count + 1 } : entry
    );
  }

  return [...licenses, { value: license, count: 1 }];
}

/**
 * Reduces an array of per-site category responses into a single summary.
 * Boolean flags are OR'd across all sites; license values are grouped
 * with a count of how many sites hold each license type.
 */
export function getSiteCategoriesUnion(
  siteCategories?: Array<SiteCategoriesResponse>
): SiteCategoriesSummaryResponse | undefined {
  return siteCategories?.reduce<SiteCategoriesSummaryResponse>(
    (union, siteCategoriesForSite) => ({
      is_eigenerzeugung_plus:
        union.is_eigenerzeugung_plus ||
        siteCategoriesForSite.is_eigenerzeugung_plus,
      is_full_feedin:
        union.is_full_feedin || siteCategoriesForSite.is_full_feedin,
      is_partial_feedin_site:
        union.is_partial_feedin_site ||
        siteCategoriesForSite.is_partial_feedin_site,
      is_ppaaas: union.is_ppaaas || siteCategoriesForSite.is_ppaaas,
      license: addOrIncrementLicense(
        union.license,
        siteCategoriesForSite.license
      )
    }),
    {
      is_eigenerzeugung_plus: false,
      is_full_feedin: false,
      license: [],
      is_partial_feedin_site: false,
      is_ppaaas: false
    } satisfies SiteCategoriesSummaryResponse
  );
}
